/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChangeAssociatedArtistsRequestEditsInner } from './ChangeAssociatedArtistsRequestEditsInner';
import {
    ChangeAssociatedArtistsRequestEditsInnerFromJSON,
    ChangeAssociatedArtistsRequestEditsInnerFromJSONTyped,
    ChangeAssociatedArtistsRequestEditsInnerToJSON,
} from './ChangeAssociatedArtistsRequestEditsInner';

/**
 * 
 * @export
 * @interface ChangeAssociatedArtistsRequest
 */
export interface ChangeAssociatedArtistsRequest {
    /**
     * OpenSearch document _id for the recording being edited
     * @type {string}
     * @memberof ChangeAssociatedArtistsRequest
     */
    documentId?: string | null;
    /**
     * 
     * @type {Array<ChangeAssociatedArtistsRequestEditsInner>}
     * @memberof ChangeAssociatedArtistsRequest
     */
    edits: Array<ChangeAssociatedArtistsRequestEditsInner>;
}

/**
 * Check if a given object implements the ChangeAssociatedArtistsRequest interface.
 */
export function instanceOfChangeAssociatedArtistsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;

    return isInstance;
}

export function ChangeAssociatedArtistsRequestFromJSON(json: any): ChangeAssociatedArtistsRequest {
    return ChangeAssociatedArtistsRequestFromJSONTyped(json, false);
}

export function ChangeAssociatedArtistsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeAssociatedArtistsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
        'edits': ((json['edits'] as Array<any>).map(ChangeAssociatedArtistsRequestEditsInnerFromJSON)),
    };
}

export function ChangeAssociatedArtistsRequestToJSON(value?: ChangeAssociatedArtistsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_id': value.documentId,
        'edits': ((value.edits as Array<any>).map(ChangeAssociatedArtistsRequestEditsInnerToJSON)),
    };
}

